import React, { useEffect } from "react";
import { faSave, faUndoAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { openConfirmAlert } from "@ctsu/react-ctsu-ui";

export const FormIsDirtyAlert = ({ setModal, onClose }) => {
  useEffect(() => {
    openConfirmAlert({
      title: "Unsaved Changes!",
      message: (
        <div>
          <p className="mt-0">
            There are unsaved changes on this tab. Please either
            <FontAwesomeIcon icon={faSave} style={{ color: "#127987" }} className="pl-1" /> <strong>Save</strong>, or
            <FontAwesomeIcon icon={faUndoAlt} style={{ color: "#127987" }} className="pl-1" /> <strong>Clear Changes</strong> before continuing with any other action.
          </p>
        </div>
      ),
      buttons: [
        {
          label: "Close",
          onClick: () => {
            setModal(false);
            if (onClose) onClose();
          },
          className: "close"
        }
      ]
    });
  }, []);

  return null;
};